import * as React from 'react'

import withCommunication, { InjectedWithCommunicationProps } from '../hocs/withCommunication'

interface InjectedDownloadExportProps {
  loaded: boolean
}

interface DownloadDataURIProps {
  fileRequest: Promise<{ file?: string | undefined }>
  fileName: string
  children: (props: InjectedDownloadExportProps) => JSX.Element
}

type Props =
  DownloadDataURIProps
  & InjectedWithCommunicationProps

const initState = {
  file: '',
}

class DownloadExport extends React.Component<Props, typeof initState> {
  public state = initState

  public componentDidMount () {
    const {
      onCommunicationInitiation,
      onCommunicationSuccess,
      onCommunicationError,
      fileRequest,
    } = this.props

    onCommunicationInitiation()

    fileRequest
      .then(({ file }) => {
        onCommunicationSuccess()

        this.setState({ file: file as string })
      })
      .catch(r => {
        onCommunicationError(r)
      })
  }

  public render () {
    const { file } = this.state
    const { children, fileName } = this.props

    const injection = { loaded: Boolean(file) }

    if (!file) {
      return children(injection)
    }

    return (
      <a
        href={`data:application/vnd.ms-excel;base64,${file}`}
        download={fileName}
      >
        {children(injection)}
      </a>
    )
  }
}

export default withCommunication(DownloadExport)



// WEBPACK FOOTER //
// ./src/components/organisms/DownloadExport.tsx